export default __webpack_public_path__ + "static/media/petrify.c58d2cee.png";